const View = ({ color = "#AF915E", ...props }: any) => {
  return (
    <svg {...props} width="16" height="17" viewBox="0 0 16 17" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 13.8333H12C12 14.2015 12.2985 14.5 12.6667 14.5H13.3333C13.7015 14.5 14 14.2015 14 13.8333V13.1667C14 12.7985 13.7015 12.5 13.3333 12.5V4.5C13.7015 4.5 14 4.20152 14 3.83333V3.16667C14 2.79848 13.7015 2.5 13.3333 2.5H12.6667C12.2985 2.5 12 2.79848 12 3.16667H4C4 2.79848 3.70152 2.5 3.33333 2.5H2.66667C2.29848 2.5 2 2.79848 2 3.16667V3.83333C2 4.20152 2.29848 4.5 2.66667 4.5V12.5C2.29848 12.5 2 12.7985 2 13.1667V13.8333C2 14.2015 2.29848 14.5 2.66667 14.5H3.33333C3.70152 14.5 4 14.2015 4 13.8333ZM12.6667 12.5C12.2985 12.5 12 12.7985 12 13.1667H4C4 12.7985 3.70152 12.5 3.33333 12.5V4.5C3.70152 4.5 4 4.20152 4 3.83333H12C12 4.20152 12.2985 4.5 12.6667 4.5V12.5ZM2.66667 3.16667V3.83333H3.33333V3.16667H2.66667ZM2.66667 13.8333V13.1667H3.33333V13.8333H2.66667ZM12.6667 3.16667V3.83333H13.3333V3.16667H12.6667ZM12.6667 13.8333V13.1667H13.3333V13.8333H12.6667Z"
        fill={color}
      />
    </svg>
  );
};
export default View;
